// How the board checks guesses. Players use the server (answers never reach
// the browser). The admin's "Test puzzle" checks locally against the form.
import axios from "axios";
import { API_BASE } from "../config";

export interface CheckResult {
  correct: boolean;
  groupIndex?: number;
  groupName?: string;
}
export interface RevealData {
  groups: string[][];
  groupNames: string[];
}
export interface GameChecker {
  check(rows: string[][]): Promise<CheckResult[]>;
  reveal(): Promise<RevealData>;
}

export const apiChecker = (gameId: string): GameChecker => ({
  check: async (rows) => (await axios.post(`${API_BASE}/api/games/${gameId}/check`, { rows })).data.results,
  reveal: async () => (await axios.post(`${API_BASE}/api/games/${gameId}/reveal`)).data,
});

// Same rules as the server's /check endpoint
export const localChecker = (groups: string[][], groupNames: string[]): GameChecker => ({
  check: async (rows) =>
    rows.map((row) => {
      const g = groups.findIndex((group) => group.includes(row[0]));
      const correct = g !== -1 && new Set(row).size === 4 && row.every((icon) => groups[g].includes(icon));
      return correct ? { correct: true, groupIndex: g, groupName: groupNames[g] || "" } : { correct: false };
    }),
  reveal: async () => ({ groups, groupNames }),
});
